import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './index.css';
import { get, getDictionaryItem, generatrURLFromTags, getTags, getVideoItemURL, getMediaHost, pathJoin, injectImageResolution, canUseDOM } from '../../utils';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../atoms/RouterLink';
import getListing from '../../utils/getListing';
import LazyPicture from '../atoms/LazyPicture';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { handleAnalitics } from '../../utils/tealium';
var isLargeImage = function isLargeImage(index, isSlider) {
  var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var length = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
  if (isSlider === false) {
    if (isMobile && length <= 4) return [0, 3].includes(index % 8);
    return [0, 7].includes(index % 8);
  }
  return false;
};
export var VideoBlock = function VideoBlock(_ref) {
  var item = _ref.item,
    isSlider = _ref.isSlider,
    index = _ref.index,
    params = _ref.params,
    analytics = _ref.analytics,
    discoverMoreLink = _ref.discoverMoreLink,
    _ref$isLarge = _ref.isLarge,
    isLarge = _ref$isLarge === void 0 ? false : _ref$isLarge,
    hostLink = _ref.hostLink,
    blockTitle = _ref.blockTitle;
  var category = get(item, 'category', []);

  //const isLarge = isSlider? false : get(item, 'featured');
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hovered = _React$useState2[0],
    setHovered = _React$useState2[1];
  var isMobile = canUseDOM ? window.matchMedia("(max-width: 768px)").matches : false;
  var width = isLarge ? '460' : '220';
  var verticalPosterImage = get(item, 'verticalPosterImage');
  var horizontalPosterImage = get(item, 'horizontalPosterImage');
  var image = isLarge ? horizontalPosterImage ? horizontalPosterImage : item.image : verticalPosterImage ? verticalPosterImage : item.image;
  var verticalGif = get(item, 'verticalGif');
  var horizontalGif = get(item, 'horizontalGif');
  var gif = isLarge ? horizontalGif ? horizontalGif : null : verticalGif ? verticalGif : null;
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), image])), width, '346');
  var gifSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), gif])), width, '346');
  return /*#__PURE__*/React.createElement("div", {
    className: "videoItem ".concat(videoItemStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "videoItem__image"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 0.8
  }, item.url && /*#__PURE__*/React.createElement(RouterLink, {
    href: getVideoItemURL(item.url),
    openInSameTab: true,
    onClick: function onClick() {
      return handleAnalitics({
        params: params,
        title: item.englishTitle,
        objectParamName: 'Banner Click Param',
        objectParams: analytics
      });
    },
    title: item.title
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeIn",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: gif && !isMobile ? 'hover-media' : ''
  }, /*#__PURE__*/React.createElement("div", {
    className: gif && !isMobile ? 'static-image' : ''
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: false
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    src: imgSrc,
    "aria-hidden": "true",
    alt: item.title
  }))), gif && !isMobile && /*#__PURE__*/React.createElement("div", {
    className: 'hovered-image'
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: false
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: gifSrc
  }), /*#__PURE__*/React.createElement("img", {
    src: gifSrc,
    "aria-hidden": "true",
    alt: item.title
  })))))))), category.length ? /*#__PURE__*/React.createElement("div", {
    className: "videoItem__categories"
  }, category.map(function (elem) {
    var ariaLabel = blockTitle ? "".concat(blockTitle, " | ").concat(elem) : elem;
    return /*#__PURE__*/React.createElement("a", {
      href: "".concat(discoverMoreLink, "?category=").concat(elem),
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabel
    }, /*#__PURE__*/React.createElement("span", null, elem));
  })) : '', item.title && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-medium videoItem__title"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getVideoItemURL(item.url),
    openInSameTab: true,
    onClick: function onClick() {
      return handleAnalitics({
        params: params,
        title: item.englishTitle,
        objectParamName: 'Title Click Param',
        objectParams: analytics
      });
    }
  }, item.title))), item.introText && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-medium videoItem__description"
  }, /*#__PURE__*/React.createElement("p", null, item.introText))));
};
var BrightcoveVideos = function BrightcoveVideos(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState3 = React.useState(['1']),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    hits = _React$useState4[0],
    setHits = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    seeMoreURLTags = _React$useState6[0],
    setSeeMoreURLTags = _React$useState6[1];
  var searchCount = Number(get(params, 'SearchCount'));
  var contextTags = getTags(get(fields, 'data.contextItem.tags'), 'tags:');
  var itemTags = getTags(get(fields, 'data.datasource.tags'), 'tags:');
  var indexName = get(params, 'SearchIndex');
  var isMobile = canUseDOM ? window.matchMedia("(max-width: 768px)").matches : false;
  var uid = get(params, 'uid');
  var itemType = 'Video Details Page';
  var headerTitle = get(fields, 'data.datasource.title.jss');
  var isSlider = get(fields, 'data.datasource.isSlider.jss.value', false);
  var discoverMoreLink = get(fields, 'data.overviewButton.link.jss.value.href');
  var discoverMoreLinkTitle = get(fields, 'data.overviewButton.title.jss.value');
  var dictionary = get(fields, 'data.dictionary');
  var seeMoreTitle = getDictionaryItem(dictionary, 'see more') || '';
  var description = get(fields, 'data.datasource.description.jss.value');
  var currentItemIdString = get(sitecoreContext, 'route.itemId');
  var currentItemId = currentItemIdString && currentItemIdString.replace(/-/g, '');
  var datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  var pageTagsCheckbox = get(fields, 'data.datasource.considerPageLevelTags.jss.value') || false;
  var pageTags = get(fields, 'data.contextItem.tags.values') || [];
  var tagsList = pageTagsCheckbox ? [].concat(_toConsumableArray(datasourceTags), _toConsumableArray(pageTags)) : _toConsumableArray(datasourceTags);
  var analytics = get(fields, 'data.analytics.parameters');
  var _useInView = useInView({
      threshold: 1,
      triggerOnce: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  if (!fields) {
    console.info('BrightcoveVideosHeader component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[BrightcoveVideosHeader component is empty: please provide data source]");
    }
    return null;
  }
  /*eslint-disable */

  React.useEffect(function () {
    if (inView) {
      setSeeMoreURLTags(generatrURLFromTags(tagsList, 'tags'));
      var itemFilter = {
        hitsPerPage: searchCount > 8 ? 8 : searchCount,
        facetFilters: [["type:".concat(itemType)], [].concat(_toConsumableArray(contextTags), _toConsumableArray(itemTags)) //[`featured:1`]
        //[contextItemId ? `curators.curators.Id:${contextItemId}` : ''],
        ],
        filters: currentItemId ? "NOT objectID:".concat(currentItemId) : ''
      };
      getListing(indexName, itemFilter).then(function (hits) {
        if (hits) {
          !isSlider && hits.hits.splice(Math.max(1, Math.floor(hits.hits.length / 4)) * 4);
          setHits(hits.hits);
        }
      });
    }
  }, [inView]);
  /*eslint-disable */

  var renderTileItems = function renderTileItems(hostLink) {
    return hits.map(function (item, index) {
      var isLarge = isLargeImage(index, isSlider, isMobile, hits.length);
      //const isLarge = isSlider? false : get(item, 'featured');
      //const itemId = get(item, 'objectID')
      // if(itemId == currentItemId)
      // 	return null
      // else
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(isLarge ? 'video__large' : 'video__medium')
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        delay: 0,
        animateOnce: true,
        duration: 1 + index / 3
      }, /*#__PURE__*/React.createElement(VideoBlock, {
        key: index,
        index: index,
        item: item,
        isSlider: isSlider,
        isLarge: isLarge,
        hostLink: hostLink,
        discoverMoreLink: discoverMoreLink,
        analytics: analytics,
        params: params,
        blockTitle: headerTitle.value
      })));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "videosCarousel--holder row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-10 offset-xl-1 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11 h-title-x"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 0
  }, /*#__PURE__*/React.createElement(Text, {
    className: "videos__title h2",
    tag: "h2",
    field: headerTitle
  }), description && /*#__PURE__*/React.createElement("p", {
    className: "videos__description"
  }, description)))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12 videos__multiple"
  }, /*#__PURE__*/React.createElement("div", {
    className: "videos__multiple--list row"
  }, !isSlider ? /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row videos__multiple--list-noCarousel"
  }, renderTileItems('')), discoverMoreLinkTitle && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 100
  }, /*#__PURE__*/React.createElement("div", {
    className: "videos__link"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-link btn-desk",
    href: discoverMoreLink + seeMoreURLTags,
    onClick: function onClick() {
      return handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'See More Param',
        objectParams: analytics
      });
    },
    ariaLabel: "".concat(headerTitle.value, " | ").concat(discoverMoreLinkTitle)
  }, discoverMoreLinkTitle, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  })), /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-primary btn-mob rs_skip",
    href: discoverMoreLink + seeMoreURLTags,
    onClick: function onClick() {
      return handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'See More Param',
        objectParams: analytics
      });
    }
    //onClick={() => tealiumClickFunc(tealiumMergeClickData(seeMoreAnalytics, params))}
  }, discoverMoreLinkTitle)))))) : /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots,
      state = _ref3.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "videos__items"
    }, renderCarousel(renderTileItems(''), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 768
          },
          items: 5
        },
        tablet: {
          breakpoint: {
            max: 1200,
            min: 768
          },
          items: 5
        },
        mobileLandscape: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 2
        }
      }
    }, function (isNext) {
      return handleAnalitics({
        params: params,
        title: '',
        objectParamName: isNext ? 'Slide Right Param' : 'Slide Left Param',
        objectParams: analytics
      });
    }), /*#__PURE__*/React.createElement("div", {
      className: "article-navigation__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "article-navigation__btn btn-group--left ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'Previous Param',
        objectParams: analytics
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: "article-navigation__btn btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderNextButton(function () {
      return handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'Next Param',
        objectParams: analytics
      });
    }))), /*#__PURE__*/React.createElement("div", {
      className: "c-pagination__dots"
    }, renderDots(function () {
      return handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'Navigator Bubbles Param',
        objectParams: analytics
      });
    }))));
  }), discoverMoreLinkTitle && /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 400
  }, /*#__PURE__*/React.createElement("div", {
    className: "videos__link"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-link btn-desk",
    href: discoverMoreLink + seeMoreURLTags,
    onClick: function onClick() {
      return handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'See More Param',
        objectParams: analytics
      });
    },
    ariaLabel: "".concat(headerTitle.value, " | ").concat(discoverMoreLinkTitle)
  }, discoverMoreLinkTitle, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  })), /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-primary btn-mob rs_skip",
    href: discoverMoreLink + seeMoreURLTags,
    onClick: function onClick() {
      return handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'See More Param',
        objectParams: analytics
      });
    }
  }, discoverMoreLinkTitle)))))))))))));
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl,
    anchorUrlParameter = _ref4.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    fullWidth: true,
    minHeight: true,
    className: " ".concat(videoMedia, " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export var videoMedia = "v1sy3slg";
var commonStyles = "c1xjsyvd";
var rtlStyles = "rh81elw";
var ltrStyles = "l11ebavu";
var videoItemStyles = "vmmzpim";
export default BrightcoveVideos;